
import { Component, Vue, Mixins, Prop } from "vue-property-decorator";

@Component
export default class Table extends Vue {
  @Prop() isChild!: boolean;
}
